import type { LabelComponentType } from "../../../../common-deprecated/components/label/Label";
import { getLabelComponent } from "../../../../common-deprecated/components/label/Label";
import type {
    UseLabelType,
    UseOptionalLabelType,
    GetLabelType,
    GetOptionalLabelType,
} from "../../../../common-deprecated/hooks/useLabel";
import {
    getUseLabel,
    getUseOptionalLabel,
    getLabelFn,
    getOptionalLabelFn,
} from "../../../../common-deprecated/hooks/useLabel";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import type { EcoConsumptionStateType } from "../redux/reducers/EcoConsumptionReducer";
import type { EcoConsumptionCostType } from "../types/EcoConsumptionType";

export const ecoConsumptionLabels = {
    ecoConsumptionCostPerYearUnit: "/Year",
    ecoConsumptionNotRelevant: "Not Relevant",
    ecoConsumptionNotSet: "",
    ecoConsumptionNotConfigured: "",
    ecoConsumptionSpecCombine: "plus",
};

export type EcoConsumptionLabelParamType = Partial<Record<keyof EcoConsumptionCostType, string | number>>;

export type EcoConsumptionLabelType = keyof typeof ecoConsumptionLabels;

export type EcoConsumptionLabelsType = typeof ecoConsumptionLabels;

export const useEcoConsumptionLabel = getUseLabel(
    (state: { ecoConsumption: EcoConsumptionStateType }) => state.ecoConsumption.labels,
    (state: { ecoConsumption: EcoConsumptionStateType; commonSettings: CommonSettingsType }) =>
        !!state.commonSettings.query.showDictionaryKeys,
) as UseLabelType<EcoConsumptionLabelType, EcoConsumptionLabelParamType>;

export const useEcoConsumptionOptionalLabel = getUseOptionalLabel(
    (state: { ecoConsumption: EcoConsumptionStateType }) => state.ecoConsumption.labels,
    (state: { ecoConsumption: EcoConsumptionStateType; commonSettings: CommonSettingsType }) =>
        !!state.commonSettings.query.showDictionaryKeys,
) as UseOptionalLabelType<EcoConsumptionLabelType, EcoConsumptionLabelParamType>;

export const getEcoConsumptionLabel = getLabelFn(
    (state: { ecoConsumption: EcoConsumptionStateType }) => state.ecoConsumption.labels,
    (state: { ecoConsumption: EcoConsumptionStateType; commonSettings: CommonSettingsType }) =>
        !!state.commonSettings.query.showDictionaryKeys,
) as GetLabelType<{ ecoConsumption: EcoConsumptionStateType }, EcoConsumptionLabelType, EcoConsumptionLabelParamType>;

export const getEcoConsumptionOptionalLabel = getOptionalLabelFn(
    (state: { ecoConsumption: EcoConsumptionStateType }) => state.ecoConsumption.labels,
    (state: { ecoConsumption: EcoConsumptionStateType; commonSettings: CommonSettingsType }) =>
        !!state.commonSettings.query.showDictionaryKeys,
) as GetOptionalLabelType<
    { ecoConsumption: EcoConsumptionStateType },
    EcoConsumptionLabelType,
    EcoConsumptionLabelParamType
>;

export const EcoConsumptionLabel = getLabelComponent(useEcoConsumptionLabel) as LabelComponentType<
    EcoConsumptionLabelType,
    EcoConsumptionLabelParamType
>;
